import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import styles from "./faqs.module.css";

const faqs = [
    {
        question: "What dialysis treatments do you provide?",
        answer:
            "We offer both hemodialysis and peritoneal dialysis, along with advanced care plans tailored to each patient’s medical needs.",
    },
    {
        question: "How can I book a dialysis session?",
        answer:
            "You can schedule your dialysis session by calling our center directly, booking online through our website, or visiting our reception desk.",
    },
    {
        question: "Do you provide emergency dialysis services?",
        answer:
            "Yes, we provide 24/7 emergency dialysis support for patients in urgent need of treatment.",
    },
    {
        question: "Can I continue my treatment if I travel?",
        answer:
            "Yes, we assist patients with travel dialysis arrangements and coordinate with partner centers so your treatment continues smoothly.",
    },
    {
        question: "Do you offer diet and lifestyle guidance?",
        answer:
            "Absolutely. Our team includes dietitians who provide personalized nutrition and lifestyle plans to support your dialysis care.",
    },
];

const FAQs = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className={styles.section}>
            <div className={styles.container}>
                <h2 className={styles.title}>Frequently Asked Questions</h2>
                <p className={styles.description}>
                    Find answers to common questions about dialysis treatments, scheduling,
                    patient care, and support services at our center.
                </p>
                <div className={styles.faqList}>
                    {faqs.map((faq, index) => (
                        <div key={index} className={styles.faqItem}>
                            <button
                                onClick={() => toggleFAQ(index)}
                                className={styles.faqButton}
                            >
                                <span className={styles.question}>{faq.question}</span>
                                {openIndex === index ? (
                                    <Minus className={styles.icon} />
                                ) : (
                                    <Plus className={styles.icon} />
                                )}
                            </button>
                            {openIndex === index && (
                                <div className={styles.answer}>{faq.answer}</div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQs;
